<div class="footerMain">
    <div class="mb-2">&copy; 2022, <span class="cultureHub">Culture Hub</span>. All rights reserved.</div>
    <div class="mb-2">A product by <a href="https://seawoodsventures.com/" target="_blank">Seawoods Ventures LLP</a></div>
    <div class="d-flex justify-content-center align-items-center"><mat-icon>cloud</mat-icon>&nbsp;&nbsp;{{version}}</div>
</div>